<template>
  <div class="text--primary">
    <v-row>
      <v-col cols="12">
        <v-card outlined class="rounded-card">
          <v-subheader class="text--primary">
            Documentos ativos
            <v-spacer></v-spacer>
            <px-fornecedor-add-documento :fornecedor="fornecedor" @update="onUpdate">
              <template v-slot:activator="{ on }">
                <v-btn v-if="hasModuleGerencia"
                       small
                       color="primary"
                       class="normal-btn-text rounded-tag-small elevation-0"
                       v-on="on">
                  <v-icon small>
                    mdi-plus
                  </v-icon>
                  Documento
                </v-btn>
              </template>
            </px-fornecedor-add-documento>
          </v-subheader>
          <v-divider/>
          <template>
            <px-lista-documentos
            :has-module-gerencia="hasModuleGerencia"
            :documentos="documentos"
            :fornecedor="fornecedor"
            :loading="loading" />
          </template>
        </v-card>
      </v-col>
    </v-row>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FornecedorAddDocumento from '../FornecedorAddDocumento.vue';
import DocumentoService from '../../gestao-fornecedor-service';
import ListaDocumentos from '../listas/ListaDocumentos.vue';

export default {
  props: {
    fornecedor: Object,
  },
  data() {
    return {
      loading: false,
      documentos: {
        content: [],
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    getDocumentos() {
      this.loading = true;
      DocumentoService.getDocumentos(this.fornecedor.id)
        .then((response) => {
          this.documentos = response.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getDocumentos();
  },
  components: {
    pxFornecedorAddDocumento: FornecedorAddDocumento,
    pxListaDocumentos: ListaDocumentos,
  },
};
</script>
